export type UrlAudience = {
  readonly job_titles: readonly string[]
  readonly industries: readonly string[]
}

export type StrategyAudience = {
  /** Who the suggested approach is written for. */
  readonly who: string
  /** Industries to add after `who` ("in ..."). Empty when `who` is the user's own text. */
  readonly industries: string
  /** The "Target:" line on the strategy card. */
  readonly summary: string
}

/**
 * Who the step 3 strategy is written for (QA D3-1).
 *
 * Step 2's "Who you sell to" is pre-filled from the URL analysis, and the user
 * can correct it there. The strategy used to read the analysis directly
 * whenever it had job titles, so a correction made in step 2 never reached
 * step 3. The user's text now wins; the analysis is the fallback only when the
 * field is empty.
 */
export function strategyAudience(target: string, analysis?: UrlAudience | null): StrategyAudience {
  const own = target.trim()
  if (own) return { who: own, industries: '', summary: own }

  const titles = analysis?.job_titles ?? []
  const industries = analysis?.industries.join(', ') ?? ''
  if (titles.length === 0) {
    return { who: 'your target audience', industries, summary: 'B2B decision-makers at growth-stage companies' }
  }
  return {
    who: titles.slice(0, 3).join(', '),
    industries,
    summary: `${titles.slice(0, 2).join(' & ')}${industries ? ` in ${industries}` : ''}`,
  }
}
